import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "left" }}>
            Hi Everyone, I am <span className="purple">Mubarak Oguntunde</span>, a
            Senior Frontend Engineer based in Lagos, Nigeria, currently
            working remotely with Corpine Lab (UK).
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Learning new coding skill
            </li>
            <li className="about-activity">
              <ImPointRight /> Research
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Mubarak</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
